<template>
  <kendo-window
      ref="kendoWindowRef"
      :title="'고객 식별 정보 일괄 업로드'"
      :modal="true"
      :width="'500px'"
      style="display:none;">
    <template>
      <div class="pop-container">
        <div class="pop-conts">
          <div>
            <p style="color:#fe5f40;font-weight:400" class="mgt10 fl">* 엑셀 파일을 선택해주세요.</p>
          </div>
          <div class="messagepop_form_wrap">
            <div class="mp_form">
              <dd>
                <kendo-upload
                    ref="upload"
                    name="files"
                    :select="fnOnSelectFile"
                    :multiple="false"
                    :files="file"
                    :show-file-list="true"
                    :async-auto-upload="false"
                    :validation-allowed-extensions='[".xlsx", ".xls"]'
                    style="'width: 300px;'">
                </kendo-upload>
              </dd>
            </div>
          </div>
          <div class="k-text-center mgt30">
            <button type="button" id="buttonUpload" class="mid_btn orange" @click="fnExecUpload">업로드</button>
          </div>
        </div>
      </div>
    </template>
  </kendo-window>
</template>

<script>
import ApiConfig from '@/api/api.config'
import ApiUtil from '@/api/api.util'

import EtnersCommonUtil from '@/common/etners.common.util'
import $ from 'jquery'
import * as XLSX from "xlsx"
import app from '@/main';

export default {
  name: 'CallerUserExcelUploadWindow',
  data: function() {
    return {
      loginUserToken: sessionStorage.getItem('loginUserToken'),
      file: [],
      uploadDataArray: [],
      corRegNoArray: [],
      wsIdArray: [],
      spTelNoArray: [],
      successList: []
    }
  },
  methods: {
    fnOnSelectFile: function(e) {
      const vm = this

      const fileInfo = e.files[0]
      app.$Progress.plus()
      setTimeout(function() {
        vm.corRegNoArray = []
        vm.wsIdArray = []
        vm.spTelNoArray = []

        const raw = fileInfo.rawFile
        const reader = new FileReader()
        const fileList = e.sender._module.element.find('ul')
        reader.onloadend = function(e) {
          let data = e.target.result
          let workbook = XLSX.read(data, {
            type: 'binary'
          })
          let successBool = true

          workbook.SheetNames.forEach((sheetName) => {
            if (sheetName === '고객식별정보') {
              const rowJson = XLSX.utils.sheet_to_json(workbook.Sheets[sheetName])

              if (rowJson.length < 4) {
                successBool = false
                kendo.alert('데이터가 존재하지 않습니다.')
                return false
              }
              if (rowJson.length >= 1003) {
                successBool = false
                kendo.alert('1000건 이상은 업데이트 할 수 없습니다.')
                return false
              }

              for (let i = 3; i < rowJson.length; i++) {
                if (rowJson[i]['_EMPTY_1'] === undefined) {
                  let corRegNo = rowJson[i]['사업자등록번호']
                  let wsId = rowJson[i]['업무공간 ID']
                  let userNm = rowJson[i]['성명']
                  let spTelNo = rowJson[i]['개인 전화번호']
                  let email = rowJson[i]['이메일']
                  let workTelNo = rowJson[i]['사무실 전화번호']

                  // 최종 입력 값
                  let inputObj = {
                    corRegNo       :   EtnersCommonUtil.isNotEmpty(corRegNo)     ? corRegNo.toString().trim()                                             : '',
                    wsId           :   EtnersCommonUtil.isNotEmpty(wsId)         ? wsId.toString().trim()                                                 : '',
                    userNm         :   EtnersCommonUtil.isNotEmpty(userNm)       ? userNm.toString().trim()                                               : '',
                    email          :   EtnersCommonUtil.isNotEmpty(email)        ? email.toString().trim()                                                : '',
                    spTelNo        :   EtnersCommonUtil.isNotEmpty(spTelNo)      ? spTelNo.toString().replace(/-/gi,"").trim()       : '',
                    workTelNo      :   EtnersCommonUtil.isNotEmpty(workTelNo)    ? workTelNo.toString().replace(/-/gi,"").trim()     : '',
                  }

                  const rowNo = (i + 1) + 1
                  const excelLineMessage = '<br>엑셀 줄번호(' + rowNo + ') : '
                  const regEmail = /^([\w-]+(?:\.[\w-]+)*)@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$/

                  // 1. 필수 입력 체크
                  // 사업자등록번호
                  if (inputObj.corRegNo === '') {
                    successBool = false
                    kendo.alert(excelLineMessage + '사업자등록번호는 필수 입력입니다.')
                    return false
                  }
                  else if(inputObj.corRegNo.length !== 10){
                    successBool = false
                    kendo.alert(excelLineMessage + '사업자등록번호는 10자리입니다.')
                    return false
                  }
                  // 업무공간ID
                  if (inputObj.wsId === '') {
                    successBool = false
                    kendo.alert(excelLineMessage + '업무공간ID는 필수 입력입니다.')
                    return false
                  }
                  else if(inputObj.wsId.length !== 4){
                    successBool = false
                    kendo.alert(excelLineMessage + '업무공간ID는 4자리입니다.')
                    return false
                  }
                  // 성명
                  if (inputObj.userNm === '') {
                    successBool = false
                    kendo.alert(excelLineMessage + '성명은 필수 입력입니다.')
                    return false
                  }
                  // 개인전화번호
                  if (inputObj.spTelNo === '') {
                    successBool = false
                    kendo.alert(excelLineMessage + '개인 전화번호는 필수 입력입니다.')
                    return false
                  }
                  // 2. 선택 입력 체크
                  // 이메일
                  if(inputObj.email !== ''){
                    if(!regEmail.test(inputObj.email)){
                      successBool = false
                      kendo.alert(excelLineMessage + '이메일 형식을 확인해주세요.')
                      return false
                    }
                  }

                  vm.uploadDataArray.push(inputObj)
                  vm.corRegNoArray.push(inputObj.corRegNo)
                  vm.wsIdArray.push(inputObj.wsId)
                  vm.spTelNoArray.push(inputObj.spTelNo)
                }
              } // end of for loop
            }
            // 업로드 실패시 array 및 fileList 제거
            if (successBool === false) {
              vm.removeFileList(fileList)
            }
          })
          //엑셀 양식이 다른 case(시트에 진입 x)
          if (successBool === true && vm.uploadDataArray.length == 0) {
            kendo.alert('샘플 엑셀양식과 다른 엑셀 파일입니다. 파일을 확인해주세요.')
            vm.removeFileList(fileList)
            return false
          } else if (successBool === true) {
            // 유효성 검사 진행
            vm.validateCheck(fileList)
          }
        }
        reader.readAsBinaryString(raw)
        app.$Progress.minus()
      })
    },
    validateCheck: function(fileList) {
      const vm = this

      let params = {
        loginUserToken: vm.loginUserToken,
        userUploadList: vm.uploadDataArray,
        corRegNoList: vm.corRegNoArray,
        wsIdList : vm.wsIdArray,
        spTelNoList : vm.spTelNoArray
      }

      app.$Progress.plus()
      let buttonUploadElem = document.querySelector('#buttonUpload')
      buttonUploadElem.setAttribute('disabled', 'disabled')

      // TODO 1. 엑셀 업로드 데이터 유효성 검사
      // 회사ID, 업무공간 ID 유효성 검사
      // 개인 전화번호 중복 체크 검사
      ApiUtil.post(`${ApiConfig.eklDomain}/v1/ebmp/ai/manager/portal/caller/checkCallerUserList.json`, params).then(response => {
        if (response.data === undefined || response.data.resultStatus === undefined) {
          kendo.alert('데이터가 정상적으로 처리되지 않았습니다.')
          vm.removeFileList(fileList)
          app.$Progress.minus()
          return false
        }
        if (response.data.resultStatus.messageCode !== '2000') {
          kendo.alert(response.data.resultStatus.messageText)
          vm.removeFileList(fileList)
          app.$Progress.minus()
          return false
        }

        let resultData = response.data.resultData

        if(resultData.boolResult){
          app.$Progress.minus()
        }
        else{
          app.$Progress.minus()
          if(EtnersCommonUtil.isNotEmpty(resultData.failMessage)){
            if(resultData.failCnt >= 10){
              resultData.failMessage += '<br><span style="color : red;">오입력된 항목이 10개이상 존재합니다. 데이터 확인 후 재등록해주세요.</span><br>'
            }

            vm.removeFileList(fileList)
            kendo.alert(resultData.failMessage)
            return false
          } else{
            vm.removeFileList(fileList)
            kendo.alert('알 수 없는 오류입니다.<br>관리자에게 문의해주세요.')
            return false
          }
        }
        buttonUploadElem.removeAttribute("disabled")
      })

    },
    fnExecUpload: function(e) {
      const vm = this
      const fileList = e.target.parentNode.parentNode.querySelector('.k-upload-sync ul')

      if (vm.uploadDataArray.length === 0) {
        kendo.alert('업로드한 자료가 없습니다.')
        return false
      }

      kendo.confirm('회원' + vm.uploadDataArray.length + '건을 업로드 하시겠습니까?').done(function() {
        let params = {
          loginUserToken: vm.loginUserToken,
          userUploadList: vm.uploadDataArray,
        }

        app.$Progress.plus()
        let buttonUploadElem = document.querySelector('#buttonUpload')
        buttonUploadElem.setAttribute('disabled', 'disabled')

        /**
         * 1. 데이터 업로드 API 호출
         */
        ApiUtil.post(`${ApiConfig.eklDomain}/v1/ebmp/ai/manager/portal/caller/uploadCallerUserList.json`, params).then(response => {
          if (response.data === undefined || response.data.resultStatus === undefined) {
            kendo.alert('데이터가 정상적으로 처리되지 않았습니다.')

            vm.removeFileList(fileList)
            buttonUploadElem.removeAttribute("disabled")
            app.$Progress.minus()
            return false
          }
          if (response.data.resultStatus.messageCode !== '2000') {
            kendo.alert(response.data.resultStatus.messageText)

            vm.removeFileList(fileList)
            buttonUploadElem.removeAttribute("disabled")
            app.$Progress.minus()
            return false
          }

          let resultData = response.data.resultData
          buttonUploadElem.removeAttribute("disabled")

          if(resultData.boolResult === false){
            kendo.alert('데이터가 정상적으로 처리되지 않았습니다.')
            vm.removeFileList(fileList)
            app.$Progress.minus()
            return false
          }
          else{
            kendo.alert('처리 되었습니다.')
            vm.successList = resultData.successList

            vm.removeFileList(fileList)
            vm.$parent.getCallerList()
            app.$Progress.minus()
            vm.$refs.kendoWindowRef.kendoWidget().close()
          }
        })
      })

    },

    removeFileList: function(fileList) {
      const vm = this
      vm.uploadDataArray = []
      vm.corRegNoArray = []
      vm.wsIdArray = []
      vm.spTelNoArray = []
      fileList.remove()
    },
  },
}
</script>
